import Help from './Help'
import HelpEdit from './HelpEdit'

export default {
  list: Help,
  edit: HelpEdit,
}
